export default __webpack_public_path__ + "static/media/img5677.b5147d7f.JPG";